import { Select, SelectProps } from "@/atoms"
import styles from "./SelectRegions.module.scss"

export const SelectRegions = (props: SelectProps) => {
  return <Select {...props} className={styles.selectRegion} mode="multiple" />
}
